import { AfterViewInit, Injectable, OnInit } from "@angular/core";
import { GeneralService } from "src/app/shared/services/general.service";

@Injectable({
    providedIn: 'root'
})

export abstract class AdDefaults implements OnInit, AfterViewInit {

    viewInit = false;

    constructor(
        protected gs: GeneralService
    ){

    }
    ngOnInit(){
        
        this.viewInit = true;
    }

    ngAfterViewInit(){
    }


    setInView(event){
        this.gs.setAction({action:'lightGalleryInView', event:event});
    }

    imgDidLoad(event){
        this.gs.imgDidLoad(event);
    }

    openGallery(adId, item, galleryList:any = false){
        this.gs.setAction({adId: adId, action:'lightGallery', item:item, galleryList : galleryList});
    }

}
